export const CONTENT_DISPLAY_NAME = "Content";
